import { FC } from "react";
import { MeetingPermissionsModalContent } from "@/components/desktop/system-permissions/meetings/meetings-permissions-modal-content";
import { RecallPermissionKind } from "@/modules/electron/types";
import { useSystemPermissionHandlers } from "@/components/desktop/system-permissions/shared";
import { PermissionStatusMap } from "@/components/desktop/system-permissions/shared/system-permissions.types";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onRestart: () => void;
  permissionStatusMap: PermissionStatusMap;
  advancedMeetingPermissionsRequired: boolean;
  onRequestPermission: (permission: RecallPermissionKind) => Promise<void>;
  onOpenPermissionPane: (permission: RecallPermissionKind) => Promise<void>;
};

export const MeetingPermissionsModal: FC<Props> = ({
  isOpen,
  onClose,
  permissionStatusMap,
  advancedMeetingPermissionsRequired,
  onRestart,
  onRequestPermission,
  onOpenPermissionPane,
}: Props) => {
  const {
    resolveConfigurationStatus,
    handleEnablePermission,
    handleOpenPermissionPane,
    restartRequired,
  } = useSystemPermissionHandlers({
    onRequestPermission,
    onOpenPermissionPane,
    permissionStatusMap,
  });

  return (
    <MeetingPermissionsModalContent
      isOpen={isOpen}
      onClose={onClose}
      resolveConfigurationStatus={resolveConfigurationStatus}
      handleEnablePermission={handleEnablePermission}
      handleOpenPermissionPane={handleOpenPermissionPane}
      restartRequired={restartRequired}
      onRestart={onRestart}
      advancedMeetingPermissionsRequired={advancedMeetingPermissionsRequired}
    />
  );
};
